import { render, staticRenderFns } from "./detailSpider.vue?vue&type=template&id=5ae13b53&"
import script from "./detailSpider.vue?vue&type=script&lang=js&"
export * from "./detailSpider.vue?vue&type=script&lang=js&"
import style0 from "./detailSpider.vue?vue&type=style&index=0&id=5ae13b53&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports